<script>
    import { onMount } from 'svelte';

    import ProductSwitcher from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/Switcher.svelte?1733898724739';
    import Stock from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/Stock.svelte?1733898724739';
    import Price from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/Price.svelte?1733898724739';
    import ConfigurableOptions from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/configurable/ConfigurableOptions.svelte?1733898724739';
    import { get_configurable_data } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/configurable/get_configurable_data.js?1733898724739';

    import Badges from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/Badges.svelte?1733898724739';
    import Buttons from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/Buttons.svelte?1733898724739';
    import Wishlist from '/srv/web/wyvr/html/releases/58819/gen/client/shop/wishlist/ToggleButton.svelte?1733898724739';
    import Compare from '/srv/web/wyvr/html/releases/58819/gen/client/shop/compare/ToggleButton.svelte?1733898724739';
    import MediaGallery from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/MediaGallery.svelte?1733898724739';

    import Header from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/layout/Header.svelte?1733898724739';
    import Intro from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/layout/Intro.svelte?1733898724739';
    import Tabs from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/layout/Tabs.svelte?1733898724739';
    import { get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724739';
    import { replace_history } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/history.js?1733898724739';
    import { get_hash } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/url_hash.js?1733898724739';
    import { url_join } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/url.js?1733898724739';

    import Delivery from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/Delivery.svelte?1733898724739';
    import Tax from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/Tax.svelte?1733898724739';
    import { default_stock } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/product/default_stock.js?1733898724739';
    import FloatingAddToCart from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/FloatingAddToCart.svelte?1733898724739';
    import { get_value_of_items, process_ga4_item } from '/srv/web/wyvr/html/releases/58819/gen/client/vendor/googletagmanager/ga4.js?1733898724739';
    import Recommendations from '/srv/web/wyvr/html/releases/58819/gen/client/recommendations/Recommendations.svelte?1733898724739';
    import CrossellSlider from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/CrossellSlider.svelte?1733898724739';

    wyvr: {
        render: 'hydrate';
        loading: 'instant';
    }

    export let product;
    export let brand;
    export let locale;
    export let currency;
    export let store;

    let pre_selected_options;
    let configurable;
    let selected_product;
    const slug = "p";
    $: sku = get_attribute_value(product, 'sku');

    ;
    onMount(() => {
        configurable = getStack('configurable');
        const simple_options = get_redirected_from_simple_options();
        if (simple_options && true) {
            pre_selected_options = simple_options;
            select_configurable({ detail: simple_options });
        }
    });

    let prev_product_sku;

    function select_configurable(e) {
        const selected_data = e.detail;

        const products_from_attribute = configurable
            .map((attribute) => {
                const value = selected_data[attribute.attribute_code];
                if (!value) {
                    return undefined;
                }
                return attribute.data[value.key];
            })
            .filter((x) => x);

        const overlapped_products = products_from_attribute.reduce((acc, curr) => {
            if (!acc) {
                return curr;
            }
            const skus = curr.map((entry) => entry.sku);
            return acc.filter((entry) => skus.indexOf(entry.sku) > -1);
        }, undefined);

        const select_product = overlapped_products.find((x) => x)?.product;

        // avoid that the product gets updated with itself
        const selected_sku = get_attribute_value(select_product, 'sku');
        if (prev_product_sku === selected_sku) {
            return;
        }
        prev_product_sku = selected_sku;

        if (select_product) {
            const url_key = get_attribute_value(select_product, 'url_key');
            // only update when the product changes
            if (get_attribute_value(selected_product, 'sku') !== selected_sku) {
                let new_url = url_join(getStack('store')?.key, slug, url_key);
                if (document?.location?.search) {
                    new_url += document.location.search;
                }
                replace_history(null, null, new_url);

                selected_product = select_product;
            }
        }
        process_ga4_item(select_product, 1).then((item) => {
            if (!item) {
                return;
            }
            const items = [item];
            gtag('event', 'view_item', {
                ecommerce: {
                    currency: getStack('currency'),
                    value: get_value_of_items(items),
                    items
                }
            });
        });

        trigger('shop-product-switch', select_product);
    }

    function merged_product(base, override) {
        const product = {};
        if (base) {
            for (const [key, value] of Object.entries(base)) {
                if (['configurable_products', 'configurable_options', 'stock', 'quantity_and_stock_status'].indexOf(key) > -1) {
                    continue;
                }
                product[key] = value;
            }
        }
        if (override) {
            for (const [key, value] of Object.entries(override)) {
                product[key] = value;
            }
            if (!product.stock) {
                product.stock = { ...default_stock };
            }
        }
        return product;
    }

    function get_redirected_from_simple_options() {
        if (get_attribute_value(product, 'type_id') !== 'configurable') {
            return undefined;
        }
        const redirect_from_simple = get_hash()?.redirect_from_simple;
        if (!redirect_from_simple) {
            return undefined;
        }
        // search product by the url_key
        const redirected_simple = product.configurable_products.find((p) => get_attribute_value(p, 'url_key') === redirect_from_simple);
        if (!redirected_simple) {
            return undefined;
        }

        let new_url = url_join(getStack('store')?.key, slug, redirect_from_simple);
        if (document?.location?.search) {
            new_url += document.location.search;
        }

        // replace the current url with the url to redirect
        replace_history(null, null, new_url);

        // get the option values from the options
        return get_options_from_product(redirected_simple);
    }

    function get_options_from_product(product) {
        // get the option values from the options
        const simple_options = {};
        for (const option of configurable) {
            const product_attribute_value = get_attribute_value(product, option.attribute_code);
            const found_option = option.values.find((option_value) => option_value.key === product_attribute_value);
            if (found_option) {
                simple_options[option.attribute_code] = found_option;
            }
        }

        return simple_options;
    }
</script>

<div class="m-product-detail">
    <div class="header">
        <ProductSwitcher {product} let:product>
            <Header {product} {brand} />
        </ProductSwitcher>
    </div>

    <div class="image">
        {#if product}
            <Badges {product} />
            <ProductSwitcher {product} let:product>
                {#if product}
                
                    <MediaGallery {product} />
                    <div>
                        <Wishlist sku={get_attribute_value(product, 'sku')} />
                        <Compare sku={get_attribute_value(product, 'sku')} />
                    </div>
                {/if}
            </ProductSwitcher>
        {/if}
    </div>

    <div class="info">
        <ProductSwitcher {product} let:product>
            {#if product && get_attribute_value(product, 'type_id') !== 'configurable'}
                <Intro {product} />
                <Price {product} {locale} {currency} />
                <Tax />
                <Delivery {product} />
                <Stock {product} />
            {/if}
        </ProductSwitcher>
        {#if configurable}
            <div class="u-line--bottom">
                <ConfigurableOptions data={configurable} on:selected={select_configurable} {pre_selected_options} />
            </div>
        {/if}

        <ProductSwitcher {product} let:product>
            {#if product}
                <Buttons {product} />
            {/if}
        </ProductSwitcher>
    </div>
</div>
<ProductSwitcher {product} let:product={simple}>
    {#if simple && get_attribute_value(simple, 'type_id') !== 'configurable'}
        <FloatingAddToCart product={simple} {locale} {currency} />
    {/if}
    <Tabs product={merged_product(product, simple)} {store} {brand} />

    <div class="m-product-crosssell-slider">
        <CrossellSlider products={product.cross_sell_products} title={window.__('recommendations.crossell')} />
    </div>

    <div class="m-product-detail__slider">
        <Recommendations product={simple} />
    </div>
</ProductSwitcher>


<style>
    .name {     grid-area: product_detail_header;     margin-bottom: 1em; } .image {     grid-area: product_detail_img;     position: relative; } .info {     margin-top: 1em;      grid-area: product_detail_data; } @media (min-width: 768px) {     .main {     display: -ms-grid;     display: grid;     -ms-grid-columns: 50% 1fr;     grid-template-columns: 50% 1fr;     grid-template-areas:         "product_detail_img product_detail_header"         "product_detail_img product_detail_data"         "product_detail_desc product_detail_desc"         "product_detail_slider product_detail_slider";     padding-top: 16px;     padding-bottom: 16px;     }     .image {         margin-right: 2rem;         min-width: 300px;     }     .info {         flex-grow: 1;     } } .main {     margin-bottom: 2em; }  div div:nth-child(2) div{     position: absolute;     right: 0;     top: 0;     text-align: right; }

    .action-buttons {
        display: flex;
        gap: 5px;
        justify-content: space-between;
    }
    .action-buttons :global(.btn) {
        flex: 1;
        box-sizing: border-box;
    }
    .image div {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
    }
    .image div :global(button) {
        display: flex;
        align-items: center;
        justify-content: end;
        flex-direction: row-reverse;
    }

    .info,
    .header {
        padding-left: 2.5vw;
    }

    :global(.old-price) {
        display: flex !important;
        justify-content: flex-start !important;
        flex-direction: column !important;
    }

    @media (max-width: 768px) {
        :global(.old-price) {
            width: auto !important;
        }
    }

    :global(.m-product-price__price-box) {
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;

        @media (min-width: 768px) {
            align-items: flex-start;
        }
    }

    :global(.price--old) {
        font-weight: normal;
    }

    :global(.price--percentage) {
        display: block !important;
        position: absolute;
        right: 0;
        bottom: 0;
        font-size: var(--font-size__xs);
        font-weight: bold;
        color: var(--red);
        padding: 0.1rem 0.35rem;
        border-radius: 2rem;
        border: 1px solid var(--red);
        transform: translate(115%, -1rem);

        @media (min-width: 768px) {
            font-size: var(--font-size__s);
            padding: 0.1rem 0.5rem;
        }
    }

    :global(.new-price) {
        position: relative;
    }
</style>